import { react } from "uikit";
import { Dispatch } from "react";

import { PaymentCurrency } from "../../../../../../../../services/PaymentSystem";

import BogPaymentsCurrency from ".";

interface Context {
	value: BogPaymentsCurrency.Value;
	setError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isValid =
			this.context?.value.bogCurrency !== PaymentCurrency.NULL;

		if (!isValid) {
			this.context?.setError(true);
			return isValid;
		}
		this.context?.setError(false);
		return isValid;
	}
}
